<template>
  <div class="main" :class="{ rtl: rtl }">
    <!-- header -->
    <mds-header
      :is-login="isLogin"
      :lan-list="lanList"
      :lan-res="lanRes"
      :img-res="imgRes"
      :user-data="userData"
      :current-lan-name="currentLanName"
      :current-lan="currentLan"
      :go-server-url="goServerUrl"
      @login="login"
    >
    </mds-header>

    <!-- container -->
    <div class="container">
      <!-- benner start -->
      <div class="banner">
        <div class="banner_pc">
          <img :src="imgRes.pdbannerpc || 'https://cdn.midasbuy.com/images/activity/visacard/pd-banner-pc.png'" />
        </div>
        <div class="banner_m">
          <img :src="imgRes.pdbannerm1 || 'https://cdn.midasbuy.com/images/activity/visacard/pd-banner-m-1.png'" />
        </div>

        <div class="banner-cont">
          <img
            class="white-visa-logo"
            :src="imgRes.bannerTitle || 'https://cdn.midasbuy.com/images/activity/visacard/images/visa_white.png'"
          />
          <img class="activity-title" :src="imgRes.activityTitle" />
          <div class="activity-date Dark-Primary">
            <div>
              <p class="TxtLoop" :style="loopDuration">{{ lanRes.activityDate }}{{ lanRes.activityTimeRange }}</p>
            </div>
          </div>
          <div class="banner-hint Light-Primary">{{ lanRes.bannerHint }}</div>
        </div>
      </div>
      <!-- benner end -->

      <div class="container-box">
        <!-- TASK ONE -->
        <div class="visa-activity-step">
          <div class="step-num Light-Primary" v-html="lanRes.taskOneNum"></div>
          <div class="step-title Primary" v-html="lanRes.taskOne"></div>
          <div class="visa-date" v-html="lanRes.visaActivityDate1"></div>
          <div class="step-det Primary" v-html="lanRes.setpOneDet"></div>
          <div class="step-det-1" v-html="lanRes.stepDet1"></div>

          <div class="step-det-2 Primary">
            <div>
              <img :src="imgRes.iconucs || 'https://cdn.midasbuy.com/images/activity/visacard/icon-ucs.png'" />
            </div>
            <div>
              <div class="max-price">{{ lanRes.stepOnePrice }}</div>
              <div>
                {{ lanRes.stepOneFree }}<span class="ori-price"> {{ lanRes.stepOneOriPrice }}</span>
              </div>
            </div>
          </div>
          <div v-if="openidBind" class="pid-box Primary">
            <p>{{ lanRes.taskOnePidver }}</p>
            <div class="pid-det">
              <div>
                <div>{{ currentBindUser.charac_name }}</div>
                <div class="Dark-Primary">{{ lanRes.taskOnePid }}{{ currentBindUser.userid }}</div>
              </div>
              <div v-if="currentBindUser.verifytype !== 'facebook'" class="hy-Primary" @click="switchClick">
                {{ lanRes.taskOneSwitch }}
              </div>
              <div class="clear-float"></div>
            </div>
          </div>

          <button
            class="step-btn Light-Primary"
            :class="{ disable: taskOneFinished || (!taskOneChance && openidBind) }"
            @click="taskOneClick"
          >
            {{ taskOneBtnText }}
          </button>
        </div>
        <div id="taskTwo" class="visa-activity-step">
          <div class="step-num Light-Primary" v-html="lanRes.taskTwoNum"></div>
          <div class="step-title Primary" v-html="lanRes.taskTwo"></div>
          <div class="visa-date" v-html="lanRes.visaActivityDate2"></div>
          <div class="step-det Primary" v-html="lanRes.taskTwoDet"></div>
          <div class="primary-line"></div>
          <div class="step-det-3">
            <div v-html="lanRes.stepDetF2"></div>
            <img :src="imgRes.iconucs || 'https://cdn.midasbuy.com/images/activity/visacard/icon-ucs.png'" />
            <div class="clear-float"></div>
          </div>

          <button
            class="step-btn Light-Primary"
            :class="{ disable: taskTwoFinished || (!taskTwoChance && openidBind) }"
            @click="taskTwoClick"
          >
            {{ taskTwoBtnText }}
          </button>
        </div>

        <div class="visa-activity-plaza">
          <h3 class="plaza-title Primary">{{ lanRes.processTitle }}</h3>
          <!-- steps -->
          <div class="steps-bar Primary">
            <div class="steps-logo">
              <img :src="imgRes.iconperson || 'https://cdn.midasbuy.com/images/activity/visacard/icon-person.png'" />
              <div class="steps-cont">
                <p>{{ lanRes.stepsPer }}</p>
              </div>
            </div>

            <div class="steps-line">
              <img
                :src="imgRes.iconstepline || 'https://cdn.midasbuy.com/images/activity/visacard/icon-step-line.png'"
              />
            </div>

            <div class="steps-logo">
              <img :src="imgRes.iconvisa || 'https://cdn.midasbuy.com/images/activity/visacard/icon-visa.png'" />
              <div class="steps-cont">
                <p>{{ lanRes.stepsVisa }}</p>
              </div>
            </div>

            <div class="steps-line">
              <img
                :src="imgRes.iconstepline || 'https://cdn.midasbuy.com/images/activity/visacard/icon-step-line.png'"
              />
            </div>

            <div class="steps-logo">
              <img :src="imgRes.iconuc || 'https://cdn.midasbuy.com/images/activity/visacard/icon-uc.png'" />
              <div class="steps-cont">
                <p>{{ lanRes.stepsUc }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="visa-activity-plaza">
          <h3 class="plaza-title Primary">{{ lanRes.ruleTitle }}</h3>
          <ol class="visa-rule Light-Primary">
            <li v-for="(item, i) in lanRes.ruleList" :key="i" v-html="item"></li>
          </ol>
        </div>
        <div class="visa-activity-plaza Primary">
          <h3 class="plaza-title Primary">{{ lanRes.reminderTitle }}</h3>
          <div class="Light-Primary">
            {{ lanRes.reminderTips }}
          </div>
          <div v-if="eventData.reminderImg" class="reminder-img">
            <img :src="eventData.reminderImg" />
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="footer"></div>

    <div v-show="showToast" class="toast-invited-tips">{{ toastMsg }}</div>

    <!-- 绑定 Playerid 提示弹窗 -->
    <div v-if="showBindUserid" class="pop-bg dialogEnterPid">
      <div class="pop-box">
        <div class="pop-close-btn" @click="playerIdCloseClick"></div>

        <div class="pop-title Primary">
          <p>{{ lanRes.dialogEnterPid.title }}</p>
        </div>

        <div class="pop-cont">
          <!-- input-id class add error -->
          <div class="input-id" :class="{ error: playerIdInvalid }">
            <input
              v-model="playerid"
              type="text"
              :placeholder="lanRes.dialogEnterPid.placeholder"
              @input="playerIdInvalid = false"
            />
            <i v-if="playerIdInvalid" class="error-close" @click="clearPlayerId"></i>
          </div>
          <div v-if="playerIdInvalid" class="error-desc">
            {{ lanRes.dialogEnterPid.errDesc }}
          </div>
        </div>

        <div class="pop-btn-group">
          <button @click="doPlayerIdLogin">{{ lanRes.dialogEnterPid.btn1 }}</button>
        </div>
      </div>
    </div>

    <!-- 卡上限提示弹窗 -->
    <div v-if="showCardManage" class="pop-bg dialogTipsLimit">
      <div class="pop-box">
        <div class="pop-close-btn" @click="closeCardmanageClick"></div>

        <div class="pop-title Primary">
          <p>{{ lanRes.dialogTipsLimit.title }}</p>
        </div>

        <div class="pop-cont">
          <p>
            {{ lanRes.dialogTipsLimit.contTxt }}
          </p>
        </div>

        <div class="pop-btn-group">
          <button class="sbtn" @click="cardManageOkClick">
            {{ lanRes.dialogTipsLimit.btn1 }}
          </button>
          <button class="mbtn" @click="jumpCardManage">
            {{ lanRes.dialogTipsLimit.btn2 }}
          </button>
        </div>
      </div>
    </div>

    <!-- 地区错误弹窗 -->
    <div v-if="showDialogErrorLocal" class="pop-bg dialogErrorLocal">
      <div class="pop-box">
        <div class="pop-close-btn" @click="handleDialogErrorLocal(false)"></div>

        <div class="pop-title Primary">
          <p>{{ lanRes.dialogTipsLimit.title }}</p>
        </div>

        <div class="pop-cont">
          <p>
            {{ lanRes.dialogTipsLimit.conTxt }}
          </p>
        </div>

        <div class="pop-btn-group">
          <button class="mbtn">{{ lanRes.dialogTipsLimit.btn1 }}</button>
        </div>
      </div>
    </div>

    <!-- 登录提示弹窗 -->
    <div v-show="showLogin" class="pop-bg dialogErrorLocal">
      <div class="pop-box">
        <div class="pop-close-btn" @click="closeDialog('Login')"></div>

        <div class="pop-title Primary">
          <p>{{ lanRes.dialogLoginFirst && lanRes.dialogLoginFirst.title }}</p>
        </div>

        <div class="pop-cont">
          <p>
            {{ lanRes.dialogLoginFirst && lanRes.dialogLoginFirst.conTxt }}
          </p>
        </div>

        <div class="pop-btn-group">
          <button class="mbtn" @click="login('logintips_login')">
            {{ lanRes.dialogLoginFirst && lanRes.dialogLoginFirst.btn1 }}
          </button>
        </div>
      </div>
    </div>

    <mds-loading :loading="loading"></mds-loading>
  </div>
</template>

<script>
import 'regenerator-runtime/runtime';
import serializeParam from '@tencent/midas-libs/dist/lib/serialize-param';
import getParams from '@tencent/midas-libs/dist/lib/get-params';
import addParam from '@tencent/midas-libs/dist/lib/add-param';
import { DrmRuleHelper } from '@tencent/midasbuy-business-libs/dist/client/drm-rule-helper';
import { user, event, payInfo, cgi, reportPv, reportAction, util, xMidasInit } from '@/utils';
import Header from '@/shared/Header/index.vue';
import Loading from '@/shared/Loading/index.vue';

let vm;
window.___global = window.VISION ? window.VISION.global : getParams();
window.__LOGINSUCCESSCALLBACK__ = function () {
  reportPv('login_callback');
  location.reload();
};
window.__CALLBACKINTERFACE = function () {
  reportPv('recharge_callback');
  vm.polling();
};

export default {
  components: {
    MdsHeader: Header,
    MdsLoading: Loading,
  },
  props: [
    'componentKey', // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
    'data', // {object} “数据”表单内容
    'styleForm', // {object} “组建自定义样式”表单内容
    'commonStyle', // {object} “组件通用wrapper样式”表单内容
    'global', // {object} 页面容器自定义的全局配置项
    'meta', // {object} 页面元数据
    'componentsMap', // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
    'getComponentByKey', // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  ],
  data() {
    return {
      eventData: {},
      bindCardList: [],
      quotaEnough: false,
      loginSubmiting: false,
      playerIdInvalid: false,
      playerid: '',
      showCardManage: false,
      showDialogErrorLocal: false,
      showBindUserid: false,
      showToast: false,
      showErrorMsg: false,
      showLangList: false,
      showEventNotStart: false,
      showEventEnd: false,
      rtl: false,
      quotaUsed: false,
      startTime: '',
      endTime: '',
      currentTime: '',
      toastMsg: '',
      currentLan: getParams().lan || 'en',
      currentLanName: 'English',
      lanRes: {
        dialogLoginFirst: {},
        taskOneBtn: {},
        taskTwoBtn: {},
        ruleList: [],
        dialogEnterPid: {},
        dialogTipsLimit: {},
        dialogErrorLocal: {},
      },
      lanList: [
        {
          name: 'English',
          key: 'en',
        },
      ],
      userData: {},
      errorMsg: '',
      loading: false,
      showLogin: false,
      links: {},
      isLogin: false,
      imgRes: {},
      taskOneChance: false,
      taskTwoChance: false,
      eventStatus: 1, // 活动状态 0：未开始 1：进行中 2：未进行
      goServerUrl: '',
      loginClickFlag: false, // 控制点击登录操作
    };
  },
  computed: {
    loopDuration() {
      return this.eventData.loopDuration ? `animation-duration: ${this.eventData.loopDuration}` : '';
    },
    taskOneFinished() {
      const now = new Date();
      const end = new Date(this.eventData.time && this.eventData.time.end1);
      return now > end;
    },
    taskTwoFinished() {
      const now = new Date();
      const end = new Date(this.eventData.time && this.eventData.time.end2);
      return now > end;
    },
    // 活动一按钮文案
    taskOneBtnText() {
      const obj = this.lanRes.taskOneBtn;
      if (!obj) return '';
      // 活动已结束
      if (this.taskOneFinished) {
        return obj.eventOver || '';
      }
      // 未登录，先登录 midasbuy
      if (!this.isLogin) {
        return obj.loginFirst || '';
      }
      // 未绑定 openid，先绑定 openid
      if (!this.openidBind) {
        return obj.notBindId || '';
      }
      // 活动一查询没资格
      if (!this.taskOneChance) {
        return obj[`noChance_${this.quotaRunOutReason}`] || obj.noChance || '';
      }
      // 活动一有资格，但绑卡数达到上限
      if (this.taskOneChance && this.bindCardList.length >= (this.eventData.maxBindCardNum || 5)) {
        return obj.maxCard;
      }
      // 有资格，且绑卡数未达上限
      return obj.topUp || '';
    },
    // 活动二按钮文案
    taskTwoBtnText() {
      const obj = this.lanRes.taskTwoBtn;
      if (!obj) return '';
      // 活动已结束
      if (this.taskTwoFinished) {
        return obj.eventOver || '';
      }
      // 未登录，先登录 midasbuy
      if (!this.isLogin) {
        return obj.loginFirst || '';
      }
      // 未绑定 openid，先绑定 openid
      if (!this.openidBind) {
        return obj.notBindId || '';
      }
      // 活动二查询没资格
      if (!this.taskTwoChance) {
        return obj.noChance || '';
      }
      return obj.topUp || '';
    },
    currentBindUser() {
      return (this.userData && this.userData.currentBindUser) || {};
    },
    openidBind() {
      return this.userData && this.userData.currentBindUser && this.userData.currentBindUser.openid;
    },
  },
  async created() {
    vm = this;
    const startDate =
      performance && performance.timing ? performance && performance.timing.navigationStart : Date.now();
    window.addEventListener('beforeunload', () => {
      reportPv(
        'view_unload',
        {
          cost: Date.now() - startDate,
        },
        true,
      );
    });
    this.initMidasLogin();
    const int = setInterval(async () => {
      if (window.xMidas) {
        clearInterval(int);
        xMidasInit();
        try {
          await this.getEventData();
          setTimeout(() => {
            reportPv('not_disappear_flash');
          }, this.eventData.flashTimeout || 5000);
          this.reportHomePv();
          this.isLogin = user.isLogin();
          if (user.isLogin() && user.getCurrentBindUser()) {
            await this.queryActivityQualification();
          }
        } catch (e) {
          console.error(e);
        } finally {
          document.getElementById('global_loading').style.display = 'none';
        }
      }
    }, 100);
  },
  methods: {
    login(from) {
      if (from) {
        reportAction(from);
      }
      reportAction('homepage_login');

      const country = (payInfo.getCountry() || 'ot').toLowerCase();
      window.midasLogin &&
        window.midasLogin.login({
          country,
          hash: '#login',
          host: location.hostname,
        });
    },
    initMidasLogin() {
      reportPv('midas_login_sdk_init');
      const locationReload = () => {
        location.href = addParam({ from: this.eventData.loginFrom || util.getFromParams() }, location.href);
      };
      const { midasLogin } = window;
      const country = (payInfo.getCountry() || 'ot').toLowerCase();
      midasLogin.on('logined', locationReload);
      midasLogin.on('loginSuccess', locationReload);
      midasLogin.on('facebookLoginSuccess', locationReload);
      midasLogin.on('registerSuccess', locationReload);
      midasLogin.on('initFail', () => {
        reportPv('midas_login_sdk_fail');
        const href = addParam({ from: this.eventData.loginFrom || util.getFromParams() }, location.href);
        location.href = `/${country}/login?redirect=${encodeURIComponent(href)}`;
      });
      midasLogin.init({
        host: location.hostname,
        country,
        hash: '#login',
        pageConfig: {
          // hideSignUp: 1, //隐藏注册模块
        },
        preload: true, // 启动预加载
      });
    },
    closeCardmanageClick() {
      reportAction('card_manage_close');
      this.closeDialog('CardManage');
    },
    cardManageOkClick() {
      reportAction('card_manage_ok');
      this.closeDialog('CardManage');
    },
    switchClick() {
      reportAction('switch_btn');
      this.openDialog('BindUserid');
    },
    queryBindCardInfo() {
      const params = {
        appid: payInfo.getAppid(),
        sandbox: getParams().sandbox || '0',
      };
      return cgi
        .getBindCardInfo(params)
        .then((res) => {
          if (Array.isArray(res.data)) {
            this.bindCardList = res.data;
          } else {
            this.bindCardList = [];
            reportPv('req_error_bindcard', { msg: 'not array' });
          }
        })
        .catch((err) => {
          this.bindCardList = [];
          reportPv('req_error_bindcard', { msg: err && err.message });
        });
    },
    async queryActivityQualification() {
      await this.queryTaskOne();
      const promiseList = [this.queryTaskTwo(), this.queryBindCardInfo(), this.queryTaskOneLimit()];
      return Promise.all(promiseList).then(() => {
        // 限次和资格都符合要求才可以参加活动一
        this.taskOneChance = this.taskOneChance && this.quotaEnough;
      });
    },
    async queryTaskOneLimit() {
      if (this.taskOneFinished) {
        return;
      }

      const drmHelper = new DrmRuleHelper({
        query_drm_limit_params: {
          ...this.getPublicParams(),
          sandbox: payInfo.getPayInfo().sandbox,
        },
        user_info: this.userData,
        limit_type: 'double',
      });

      const { info, mp_info } = this.taskOneInfo;
      const productList = info.productid_list.find((item) => item.id === 'os_credit_card');

      await drmHelper
        .mapDrmRules({
          mpInfo: mp_info,
          productList: productList.productid_info.map((info) => ({
            ...info,
            targetChannel: productList.id,
          })),
        })
        .then((res) => {
          const productInfo = res.filter(
            (item) => item.productid === this.eventData.productidMap[payInfo.getCountry()],
          )[0];
          const { quotaInfo = {} } = productInfo || {};
          const { isRunOut, runOutLimitType = '', runOutCycleType = '' } = quotaInfo.runOutInfo || {};
          this.quotaEnough = !isRunOut;
          this.quotaRunOutReason = [runOutLimitType, runOutCycleType].filter(Boolean).join(',');
        });

      return;
    },
    queryTaskOne() {
      const data = this.getPublicParams();
      data.p_type = 'bg';
      data.buyType = 'bg';
      data.type = 'xx';
      data.provide_type = 'uni_pdt';
      data.productid = this.eventData.productidMap[payInfo.getCountry()];
      const params = {
        ...data,
        ...this.eventData.taskOneExtend,
      };
      return cgi
        .getDrmInfo(params)
        .then((res) => {
          if (res.data.ret === 0) {
            this.taskOneInfo = res.data;
            const str = JSON.stringify(res.data.mp_info);
            if (str.indexOf(this.eventData.taskOneRuleid) !== -1) {
              reportPv('taskone_chance_valid');
              this.taskOneChance = true;
            } else {
              reportPv('taskone_chance_invalid');
              this.taskOneChance = false;
            }
          } else {
            reportPv('taskone_chance_err', { code: res.data.ret });
          }
        })
        .catch((err) => {});
    },
    async polling() {
      function delay(timeout) {
        return new Promise((resolve) => setTimeout(resolve, timeout));
      }
      const { maxPollNum } = this.eventData;
      const pollTimeArr = Array.isArray(this.eventData.pollTimeArr)
        ? JSON.parse(JSON.stringify(this.eventData.pollTimeArr))
        : [];
      this.loading = true;
      for (let i = 0; i < maxPollNum; i++) {
        const timeout = pollTimeArr.pop() || '1500';
        await delay(timeout);
        await this.queryTaskTwo();
        if (this.taskTwoChance) {
          this.loading = false;
          this.toast(this.lanRes.gotTaskTwoChance || 'Congratulations, you can join task two now!');
          if (window.scrollTo) {
            window.scrollTo({
              x: 0,
              y: document.getElementById('taskTwo').offsetTop,
              behavior: 'smooth',
            });
          }
          break;
        }
      }
      this.loading = false;
    },
    queryTaskTwo() {
      const data = this.getPublicParams();
      data.buytype = 'save';
      data.drm_info = this.getDrmInfo({ group_id: this.eventData.taskTwoGroupid });
      return cgi
        .getDrmInfo(data)
        .then((res) => {
          if (res.data.ret === 0) {
            const str = JSON.stringify(res.data.mp_info);
            if (str.indexOf(this.eventData.taskTwoRuleid) !== -1) {
              this.taskTwoChance = true;
            } else {
              this.taskTwoChance = false;
            }
          } else {
            reportPv('req_error_tasktwo', {
              ret: res.data.ret,
            });
          }
        })
        .catch((err) => {
          reportPv('req_error_tasktwo', {
            msg: err && err.message,
          });
        });
    },
    taskOneClick() {
      if (this.taskOneFinished) return;
      if (!this.checkLogin('task_one')) return;
      if (!this.taskOneChance) return;
      // 绑卡数达到上限
      if (this.bindCardList.length >= (this.eventData.maxBindCardNum || 5)) {
        reportAction('task_one_manage');
        return this.openDialog('CardManage');
      }
      reportAction('task_one_topup');
      this.jumpBindcard();
    },
    taskTwoClick() {
      if (this.taskTwoFinished) return;
      if (!this.checkLogin('task_two')) return;
      if (!this.taskTwoChance) return;
      reportAction('task_two_topup');
      this.goTopup();
    },
    jumpCardManage() {
      reportAction('card_manage_jump');
      const manageLocation = `/midasbuy/${payInfo.getCountry().toLowerCase()}/usercenter#cardmanage`;
      if (this.eventData.jumpCardType === 'currentTab') {
        location.href = manageLocation;
      } else {
        window.open(manageLocation);
      }
    },
    jumpBindcard() {
      const publicParams = this.getPublicParams();
      const { eventData } = this;
      const params = {
        ...publicParams,
        productid: eventData.productidMap[payInfo.getCountry()],
        pendingUrl: `https://${location.hostname}/callback/pending`,
        successUrl: `https://${location.hostname}/callback/success`,
        failUrl: `https://${location.hostname}/callback/fail`,
        provide_type: 'uni_pdt',
        product_num: 1,
        version: 'midasbuy_v2',
        channel: 'creditcard',
        id: 'os_credit_card',
        action: 'pay',
        newtab: 1,
        ...eventData.taskOneJumpExtend,
      };
      midas.buyGoods(params);
    },
    clearPlayerId() {
      this.playerid = '';
      this.playerIdInvalid = false;
    },
    playerIdCloseClick() {
      reportAction('playerid_close');
      this.closeDialog('BindUserid');
    },
    doPlayerIdLogin() {
      if (this.loginSubmiting) {
        return;
      }
      reportAction('playerid');
      const params = {
        ...this.getPublicParams(),
        openid: this.playerid,
      };
      if (payInfo.getShortOpenidRule()) {
        const reg = new RegExp(payInfo.getShortOpenidRule());
        if (!reg.test(this.playerid)) {
          this.playerIdInvalid = true;
          return;
        }
      }
      this.loginSubmiting = true;
      cgi
        .playerIdLogin(params)
        .then((res) => {
          if (res.data.ret === 0) {
            location.reload();
          } else {
            reportPv('dialog_playerid_error');
            this.playerIdInvalid = true;
            this.loginSubmiting = false;
          }
        })
        .catch((e) => {
          this.loginSubmiting = false;
        });
    },
    toast(msg) {
      this.toastMsg = msg;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, this.eventData.toastTime || 2500);
    },
    copyLink(norecheck) {
      this.toast(this.lanRes.linkCopied || 'COPIED LINK SUCCESSFUL! GO INVITE YOUR FRIENDS TO GET RECHECKIN!');
      if (norecheck === true) {
        reportAction('shareevent_eventend_copy');
      } else {
        reportAction('shareevent_resign_copy');
        this.recheckFlag = true;
      }
    },
    getPublicParams() {
      return {
        appid: payInfo.getAppid(),
        drm_info: this.getDrmInfo(),
        openid: payInfo.getOpenid(),
        pf: payInfo.getPf(),
        zoneid: payInfo.getZoneid(),
        eventid: 'visacard',
        cgi_extend: serializeParam({ muid: user.getMidasUid() }, true),
        currency_type: payInfo.getCurrencyType(),
        country: (payInfo.getCountry() || '').toUpperCase(),
        midasbuyArea: payInfo.getMidasbuyArea(),
        from: util.getFromParams(),
        sandbox: getParams().sandbox || '0',
        _id: Math.random(),
      };
    },
    getEventStatus({ current_time, end_time, start_time }) {
      if (current_time < start_time) {
        this.leftSeconds = Math.floow((start_time - current_time) / 1000);
        return (this.eventStatus = 0);
      }
      if (current_time > end_time) {
        return (this.eventStatus = 2);
      }
      this.eventStatus = 1;
    },
    getDrmInfo(options) {
      const obj = {
        country: payInfo.getCountry().toUpperCase(),
        area: payInfo.getMidasbuyArea(),
        midasbuyArea: payInfo.getMidasbuyArea(),
        version: '3.0',
      };
      if (options) {
        if (typeof options.group_id === 'string') {
          obj.group_id = options.group_id;
        }
      } else if (typeof event.getGroupId() === 'string') {
        obj.group_id = event.getGroupId();
      }
      if (user.getMidasUid()) {
        obj.muid = user.getMidasUid();
      }
      return serializeParam(obj, true);
    },
    followFb() {
      window.open(this.links.fblink || 'https://www.facebook.com/midasbuy');
    },
    goPrivacyPolicy() {
      reportAction('collectinfo_privacy');
      reportPv('collectinfo_privacy');
      window.open(this.links.privacystatement || `https://${location.hostname}/oversea_web/static/privacy.html`);
    },
    showError({ msg, code, type }) {
      if (type) {
        reportPv(`error_${type}`);
      }
      this.errorMsg = (msg || 'System busy, please try again later.') + (code ? `(code:${code})` : '');
      this.showErrorMsg = true;
      console.error(msg);
    },
    loginFirst() {
      reportPv('logintips');
      this.showLogin = true;
    },
    loginAction() {
      const country = (payInfo.getCountry() || 'ot').toLowerCase();
      window.midasLogin &&
        window.midasLogin.login({
          country,
          hash: '#login',
          host: location.hostname,
        });
    },
    goTopup() {
      reportAction('topupuc');
      if (!this.checkLogin()) return;
      const params = this.eventData.topupParams ? `?${serializeParam(this.eventData.topupParams)}` : '';
      const country = (payInfo.getCountry() || 'ot').toLowerCase();
      const { gameShortUrl } = this.gameData;
      const shopcode = this.eventData.shopcode || 'midasbuy';
      const href = `/${shopcode}/${country}/buy/${gameShortUrl}${params}`;
      window.open(href);
    },
    openDialog(type) {
      const needLogin = [];
      if (needLogin.includes(type) && !user.isLogin()) {
        return this.login();
      }
      reportPv(`dialog_${type.toLowerCase()}`);
      this[`show${type}`] = true;
    },
    closeDialog(type) {
      reportAction(`close_dialog_${type.toLowerCase()}`);
      this[`show${type}`] = false;
    },
    checkLogin(taskNum) {
      if (!user.isLogin()) {
        reportPv(`${taskNum ? `${taskNum}_` : ''}login`);
        this.loginFirst();
        return false;
      }
      if (!user.getCurrentBindUser()) {
        reportPv(`${taskNum ? `${taskNum}_` : ''}bindplayerid`);
        this.openDialog('BindUserid');
        return false;
      }
      return true;
    },
    getEventData() {
      const { appid, eventid, country } = window.___global;
      const lan = getParams().lan || 'en';
      const params = {
        eventid,
        appid,
        country,
        lan,
        _id: Math.random(),
      };

      return cgi
        .getEventData(params)
        .then((res) => {
          if (res.data.ret === 0) {
            event.setEventData(res.data.eventData);
            this.eventData = res.data.eventData;
            user.setUserData(res.data.userData);
            this.channelMap = res.data.channelMap;
            this.userData = res.data.userData || {};
            if (this.userData && this.userData.currentBindUser) {
              try {
                this.userData.currentBindUser.charac_name = decodeURIComponent(
                  this.userData.currentBindUser.charac_name,
                );
              } catch (e) {}
            }
            payInfo.setPayInfo(res.data.payInfo);
            this.lanRes = res.data.lanRes;
            this.lanRes.ruleList = [];
            for (let i = 1; i < 10; i++) {
              if (this.lanRes[`ruleList${i}`]) {
                this.lanRes.ruleList.push(this.lanRes[`ruleList${i}`]);
              } else {
                break;
              }
            }
            if (this.lanRes.pageTitle) {
              document.title = this.lanRes.pageTitle;
            }
            this.lanList = res.data.lanList || [];
            this.imgRes = res.data.imgRes || {};
            this.gameData = res.data.gameData || {};
            this.rtl = !!this.lanRes.rtl;
            const l = this.lanList.find((e) => this.currentLan === e.key);
            this.currentLanName = l ? l.name : this.currentLan;
            this.goServerUrl = res.data.goServerUrl;
            this.links = res.data.links;
            window.reportUrl = res.data.reportUrl || window.reportUrl;
            if (!user.isLogin()) this.initMidasLogin();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reportHomePv() {
      let iformat = 'homepage';
      if (this.eventNotStart) {
        iformat += '_notstart';
      } else if (this.eventStarted) {
        iformat += '_started';
      } else if (this.eventEnded) {
        iformat += '_end';
      }
      reportPv(iformat, {
        waitpagetime: 1,
      });
    },
  },
};
</script>

<style src="./assets/css/rem.css"></style>
<style src="./assets/css/reset.css"></style>
<style src="./assets/css/hint.css"></style>
<style src="./assets/css/wenk-tooltip.css"></style>
<style src="./assets/css/visa-activity.css"></style>
<style>
@media (min-width: 768px) {
  .toast-invited-tips {
    padding: 0.12rem 0.26rem;
    font-size: 24px;
  }
}
</style>
